import * as d3_array from 'd3-array'

export function create_index(data, index_field_accessor, sort_comparator=null, sort_accessor=null) {
    let rollup_fn = sort_comparator ? 
        v => v.sort((a,b) => sort_comparator(sort_accessor(a), sort_accessor(b))) : 
        v => v
    
    return d3_array
        .rollup(
            data,
            rollup_fn,
            index_field_accessor
        )
}